export default __webpack_public_path__ + "static/media/package.be6fb999.svg";